import { apiProductsList } from "api/productApi";
import BasicSelect from "components/BasicInputs/BasicSelect";
import { useFormikContext } from "formik";
import { useAppDispatch, useAppSelector } from "../../../../../../store/store";

export default function Product({ row }: { row: MaterialOrderRow }) {
  const dispatch = useAppDispatch();
  const store = useAppSelector((x: any) => x);
  const token = store.businessReducer.business.token;
  const data = useFormikContext<MaterialOrderData>();
  const v = data.values;

  return (
    <BasicSelect
      options={store.productReducer.allProducts}
      withSearch
      withRefresh
      defaultValue={row.ProductId}
      refreshList={() => dispatch(apiProductsList({ token }))}
      onChange={(val, option: any) => {
        const newRows = [...(v.materialsRows || [])];
        const index = newRows.findIndex((x) => x.ind === row.ind);
        if (index > -1) {
          newRows[index] = {
            ...row,
            ProductId: option.id,
            Product: option,
            unit: option.unit,
            subUnit: option.subUnit,
            selectedUnit: option.unit,
            conversionRatio: option.conversionRatio,
            unitPrice: option.buyPrice || 0,
          };
        }
        data.setFieldValue("materialsRows", newRows);
      }}
    />
  );
}
